import React from "react";
import "./SimpleThemedButton.css";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";

function SimpleThemedButton({
  onBtnClick = () => {},
  buttonText = "Click Me",
  variant = "default", // default | success | info | error
  btnDisabled = false,
  isLoading = false,
  loaderTxt="Submitting",
  title,
}) {
  return (
    <button
    title={title}
      className={`stb-btn stb-${variant}`}
      disabled={btnDisabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onBtnClick(e);
      }}
    >
      {isLoading ? (
        <span
        title={title}
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "0.5rem",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <IOSSpinner spinnerColor="white" /> {loaderTxt}
        </span>
      ) : (
        buttonText
      )}
    </button>
  );
}

export default SimpleThemedButton;
